var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRurkiFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_171:20122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#3C737C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8401 67.5675C66.0168 71.4629 62.1917 73.9534 58.2963 73.1302C54.4009 72.307 51.9104 68.4818 52.7336 64.5864C53.5568 60.691 57.382 58.2005 61.2774 59.0238C65.1728 59.847 67.6633 63.6722 66.8401 67.5675Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0977 68.6552C54.4372 71.6172 49.8792 71.8615 46.9173 69.2009C43.9553 66.5403 43.711 61.9824 46.3716 59.0204C49.0321 56.0585 53.5901 55.8142 56.5521 58.4747C59.514 61.1353 59.7583 65.6933 57.0977 68.6552Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1166 64.7331C44.3314 65.9679 40.262 63.9004 39.0272 60.1153C37.7924 56.3302 39.8599 52.2607 43.645 51.026C47.4301 49.7912 51.4995 51.8586 52.7343 55.6437C53.9691 59.4288 51.9017 63.4983 48.1166 64.7331Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2996 56.8397C38.4042 56.0165 35.9137 52.1913 36.7369 48.2959C37.5602 44.4005 41.3853 41.91 45.2807 42.7332C49.1761 43.5564 51.6666 47.3816 50.8434 51.277C50.0202 55.1724 46.195 57.6629 42.2996 56.8397Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2121 47.0974C38.2501 44.4368 38.0058 39.8788 40.6664 36.9169C43.327 33.9549 47.8849 33.7106 50.8469 36.3712C53.8088 39.0318 54.0531 43.5897 51.3926 46.5517C48.732 49.5136 44.174 49.758 41.2121 47.0974Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1377 38.1161C43.9029 34.331 45.9703 30.2615 49.7554 29.0267C53.5405 27.7919 57.61 29.8594 58.8448 33.6445C60.0796 37.4296 58.0121 41.499 54.227 42.7338C50.4419 43.9686 46.3724 41.9012 45.1377 38.1161Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0276 32.3027C53.8508 28.4073 57.676 25.9168 61.5714 26.74C65.4668 27.5632 67.9573 31.3884 67.1341 35.2838C66.3109 39.1792 62.4857 41.6697 58.5903 40.8465C54.6949 40.0233 52.2044 36.1981 53.0276 32.3027Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7699 31.208C65.4305 28.246 69.9885 28.0017 72.9504 30.6623C75.9124 33.3229 76.1567 37.8808 73.4961 40.8428C70.8355 43.8047 66.2776 44.049 63.3156 41.3885C60.3537 38.7279 60.1094 34.1699 62.7699 31.208Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7545 35.1372C75.5397 33.9024 79.6091 35.9698 80.8439 39.7549C82.0787 43.5401 80.0112 47.6095 76.2261 48.8443C72.441 50.0791 68.3716 48.0116 67.1368 44.2265C65.902 40.4414 67.9694 36.372 71.7545 35.1372Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.568 43.0306C81.4634 43.8538 83.9539 47.6789 83.1307 51.5743C82.3075 55.4697 78.4823 57.9602 74.5869 57.137C70.6915 56.3138 68.201 52.4886 69.0242 48.5932C69.8475 44.6978 73.6726 42.2073 77.568 43.0306Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.659 52.7729C81.621 55.4334 81.8653 59.9914 79.2047 62.9534C76.5441 65.9153 71.9862 66.1596 69.0242 63.499C66.0623 60.8385 65.818 56.2805 68.4785 53.3186C71.1391 50.3566 75.6971 50.1123 78.659 52.7729Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7334 61.7542C75.9682 65.5393 73.9008 69.6087 70.1157 70.8435C66.3306 72.0783 62.2611 70.0109 61.0263 66.2258C59.7915 62.4406 61.859 58.3712 65.6441 57.1364C69.4292 55.9016 73.4986 57.9691 74.7334 61.7542Z",
    stroke: "#D0E064",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 11.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_171:20122",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.45098 0 0 0 0 0.486275 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171:20122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_171:20122",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRurkiFilled);
export default __webpack_public_path__ + "static/media/rurki_filled.20ea5333.svg";
export { ForwardRef as ReactComponent };